import { render, staticRenderFns } from "./PhotoBlockWithZoom.vue?vue&type=template&id=120841b8&"
import script from "./PhotoBlockWithZoom.vue?vue&type=script&lang=js&"
export * from "./PhotoBlockWithZoom.vue?vue&type=script&lang=js&"
import style0 from "./PhotoBlockWithZoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports